import L from "leaflet";
import { useEffect, useRef } from "react";

import accessIconImg from "../assets/images/access-icon.png";
import coalitionIconImg from "../assets/images/coalition-icon.png";
import equipmentIconImg from "../assets/images/equipment-icon.png";
import literacyIconImg from "../assets/images/literacy-icon.png";
import secondaryIconImg from "../assets/images/secondary-icon.png";

function useLegend(map) {
  const hasAdded = useRef(false);

  useEffect(() => {
    if (map && !hasAdded.current) {
      // const legend = L.control({ position: "bottomleft" });

      // legend.onAdd = () => {
      //   const div = L.DomUtil.create("div", "info legend");
      //   div.innerHTML =
      //     "<ul><h4>Community Level Impact</h4><p style='width:155px; line-height:1.5;'>Since 2021, ECCF’s Advancing Digital Equity initiative has supported more than 13,000 individuals across Essex County.</p><li><div class='legend-color-block' style='background-color:#00739a;'></div>> 1000 individuals</li><li><div class='legend-color-block' style='background-color:#41a4c5;'></div>100 - 1000 individuals</li><li><div class='legend-color-block' style='background-color:#afe1f2;'></div>< 100 individuals</li></ul>";
      //   return div;
      // };

      // legend.addTo(map);

      const textbox = L.control({ position: "topright" });

      textbox.onAdd = () => {
        const div = L.DomUtil.create("div", "info legend");
        div.innerHTML =
          "<div style='text-align:left; width:150px;'>" +
          "<h4>Investment Areas</h4>" +
          "<div class='metric-info-hover'>" +
          `<img src='${accessIconImg}' style='height: 25px; position: relative; top: 6px;'>` +
          "<strong>Access</strong>" +
          "<span>i</span><p>Increasing available opportunities for affordable, quality Wifi or broadband internet service.</p>" +
          "</div><div class='metric-info-hover'>" +
          `<img src='${coalitionIconImg}' style='height: 25px; position: relative; top: 6px;'>` +
          "<strong>Coalition</strong>" +
          "<span>i</span><p>Uniting cross-sector leaders in a coalition to generate ideas, form partnerships and share information to find sustainable solutions to our region's digital inequities.</p>" +
          "</div><div class='metric-info-hover'>" +
          `<img src='${equipmentIconImg}' style='height: 25px; position: relative; top: 6px;'>` +
          "<strong>Equipment</strong>" +
          "<span>i</span><p>Working collaboratively with community partners to equip residents with the hardware necessary to connect to and utilize the internet.</p>" +
          "</div><div class='metric-info-hover'>" +
          `<img src='${literacyIconImg}' style='height: 25px; position: relative; top: 6px;'>` +
          "<strong>Literacy</strong>" +
          "<span>i</span><p>Amplifying digital literacy programming designed to train residents to operate digital devices and successfully navigate the internet.</p>" +
          "</div><div class='metric-info-hover'>" +
          `<img src='${secondaryIconImg}' style='height: 26px; padding: 8px; position: relative; top: 8px;'>` +
          "<strong>Secondary</strong>" +
          "<span>i</span><p>Secondary sites are locations served by primary sites.</p>" +
          "</div></div>";
        return div;
      };

      textbox.addTo(map);

      hasAdded.current = true;
    }
  }, [map]);
}

export default useLegend;
